module.exports = __webpack_public_path__ + "static/media/fastsport_icon.b6677eeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fastsport_icon.svg
// module id = 374
// module chunks = 7